import { render, staticRenderFns } from "./SociHelper.vue?vue&type=template&id=6f72fd6c"
import script from "./SociHelper.vue?vue&type=script&lang=js"
export * from "./SociHelper.vue?vue&type=script&lang=js"
import style0 from "./SociHelper.vue?vue&type=style&index=0&id=6f72fd6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports